export default "__VITE_ASSET__Bn_3LYpX__"